//#region import libraries
import React, { useEffect } from "react";
// custom components
import { Title, NewScreen } from "_atoms";
import { Calendar } from "_organisms";

// bootstrap
import { Row, Col } from "react-bootstrap";

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectUserDb } from "_redux/slices/main-screen/user";
import { reset as resetForm } from "_redux/slices/assistance-bookings/booking-form";

// styling
import { Spacing } from '_styles';
//#endregion

const BookingCalendar = (props) => {
  //#region redux
  const dispatch = useDispatch();
  const dbUser = useSelector(selectUserDb);
  //#endregion


  useEffect(() => {
    dispatch(resetForm());
  }, [dbUser]);

  return (
    <NewScreen>
      <Row>
        <Col>
          <Title
            subtitle={"Bookings Calendar"}
            description={"View your prm bookings and forecasted counts for an entire month"}
          />
        </Col>
      </Row>

      <Row style={{ marginTop: -Spacing.SCALE_22 }}>
        <Calendar />
      </Row>

    </NewScreen>
  );
};



export default BookingCalendar;
